import React from 'react'

export interface PublicAdministrationConfirmationModalProps {
  variant?: 'add' | 'remove'
}

export const PublicAdministrationConfirmationModal = ({
  variant = 'add'
}: PublicAdministrationConfirmationModalProps): JSX.Element => {
  if (variant === 'remove') {
    return (
      <>
        Tem certeza de que deseja remover este órgão público como residente?{' '}
        Ao remover, o órgão deixará de ter acesso à área logada da plataforma Espaço Teia.
      </>
    )
  }
  return (
    <>
      Tem certeza de que deseja adicionar este órgão público como residente?{' '}
      Ao adicionar, o órgão passará ter acesso à área logada da plataforma Espaço Teia.
    </>
  )
}
